import { filterFormEntries } from '@contracts/order/FormEntriesFilter';
import type { ClientOrderSubmissionState } from '@src/orders/domain/ClientOrderSubmissionState';
import { sanitizeEditOrderInputs } from '@src/orders/schemas/SanitizeEditOrderInputs';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUpdateOrder = ({
  orderId,
  onSuccess,
  onError,
}: {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation<
    void,
    Error,
    {
      data: Record<string, unknown>;
      fields?: string[];
      clientSubmissionState?: ClientOrderSubmissionState;
    }
  >({
    mutationFn: async ({
      data,
      fields,
      clientSubmissionState,
    }): Promise<void> => {
      const sanitized = sanitizeEditOrderInputs(data);
      const filtered = fields
        ? filterFormEntries(sanitized, fields)
        : sanitized;
      await OrdersClient.update(orderId, filtered, clientSubmissionState);
    },
    onSuccess,
    onError,
  });

  return {
    updateOrder: mutate,
    isPending,
  };
};
